import { initialTableShow } from 'utils/settings';

export const CLOUD_MANAGEMENT_LOGS_URL_PREFIX = '/cs/cloud-management-log';

export const mainTableConf = [
  {
    type: 'companyName',
    isSortable: true,
    field: 'companyName',
    title: 'Tenant',
    show: true,
    width: 312,
    valuesExport: ['companyName', 'customerType', 'companySize', 'customerId']
  },
  {
    isSortable: true,
    field: 'action',
    title: 'Action',
    show: true,
    width: 136,
    valuesExport: ['action']
  },
  {
    isSortable: true,
    field: 'status',
    title: 'Status',
    show: true,
    width: 162,
    valuesExport: ['status']
  },
  {
    isSortable: true,
    field: 'updatedByName',
    title: 'Updated By',
    show: true,
    width: 280,
    valuesExport: ['updatedByName', 'updatedByEmail']
  },
  {
    isSortable: true,
    field: 'datetime',
    title: 'Created At',
    show: true,
    width: 136,
    valuesExport: ['datetime']
  }
];

export const defaultNavigation = {
  fieldName: 'datetime',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};

export const exportConfig = {
  exportUrl: '/cloud/management/logs/list/export',
  exportName: 'cloudManagementLogs',
  exportFormat: 'zip'
};

export const defaultFilters = {
  search: '',
  action: [],
  status: [],
  datetime: { startDate: null, endDate: null },
  networkVersion: [],
  batchId: [],
  updatedByName: [],
  'entities.gatewayImageVersion': [],
  isTestTenant: false,
  ...defaultNavigation
};
